function excludeDaysFilter() {
    'ngInject';

    return (days, excluded) =>
        _.filter(days, day => excluded.indexOf(day.date.format('dddd')) === -1);
}

/**
 * @ngdoc filter
 * @name exclude_days
 * @kind function
 *
 * @description
 * Formats a phone number using provided country code. If no country code is passed in, the country of the current company is used.
 *
 * @param {array} days Array of BBModel.Day objects
 * @param {array} excluded String array of days to exclude, e.g. ['Saturday','Sunday']
 * @returns {array} Filtered array excluding specificed days
 *
 */
angular
    .module('BB')
    .filter('exclude_days', excludeDaysFilter);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/exclude_days.filter.js